import React from 'react';

// Generic component για DL3, DL5-DL12
const GenericDL = ({ dlType, formData, updateFormData }) => {
  const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  const validateAMKA = (amka) => {
    return /^\d{11}$/.test(amka);
  };

  const handleAMKAChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 11) {
      updateFormData({ patientAmka: value });
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 15) {
      updateFormData({ phone: value });
    }
  };

  // Configuration per DL type
  const config = {
    DL3: {
      title: 'Αντίγραφο ιατρικού φακέλου επίσκεψης στα ΤΕΠ',
      fields: ['amka', 'visitDate', 'examType', 'email', 'phone'],
      examTypes: ['Ιατρική γνωμάτευση', 'Μικροβιολογικές', 'Καρδιογράφημα', 'Ακτινογραφία']
    },
    DL5: {
      title: 'Πόρισμα εξέτασης',
      fields: ['amka', 'examDate', 'email', 'phone']
    },
    DL6: {
      title: 'Μικροβιολογικές εξετάσεις',
      fields: ['amka', 'examDate', 'email', 'phone']
    },
    DL7: {
      title: 'Πρακτικό χειρουργείου',
      fields: ['amka', 'surgeryDate', 'clinic', 'email', 'phone']
    },
    DL8: {
      title: 'Τοξικολογικές',
      fields: ['amka', 'examDate', 'email', 'phone']
    },
    DL9: {
      title: 'Εξιτήριο',
      fields: ['amka', 'period', 'clinic', 'email', 'phone']
    },
    DL10: {
      title: 'Βεβαίωση νοσηλείας',
      fields: ['amka', 'admissionDate', 'email', 'phone']
    },
    DL11: {
      title: 'Ιατρική γνωμάτευση νοσηλείας',
      fields: ['amka', 'period', 'clinic', 'email', 'phone']
    },
    DL12: {
      title: 'Συγκεντρωτική κατάσταση νοσηλειών',
      fields: ['amka', 'timePeriod', 'email', 'phone']
    }
  };

  const currentConfig = config[dlType] || config.DL5;
  const fields = currentConfig.fields || [];

  return (
    <div>
      <div className="alert alert-info" style={{ marginBottom: '20px' }}>
        <p style={{ margin: 0 }}>
          <strong>Οδηγία:</strong> Παρακαλούμε συμπληρώστε τα παρακάτω πεδία (* Υποχρεωτικά)
        </p>
      </div>

      {fields.includes('amka') && (
        <div className="form-group">
          <label htmlFor="patientAmka">
            ΑΜΚΑ ασθενή <span className="required">*</span>
          </label>
          <input
            type="text"
            id="patientAmka"
            name="patientAmka"
            value={formData.patientAmka || ''}
            onChange={handleAMKAChange}
            placeholder="12345678901"
            maxLength="11"
            required
          />
          {formData.patientAmka && !validateAMKA(formData.patientAmka) && (
            <small style={{ color: '#e74c3c', display: 'block', marginTop: '5px' }}>
              Το AMKA πρέπει να είναι ακριβώς 11 ψηφία
            </small>
          )}
        </div>
      )}

      {fields.includes('period') && (
        <div className="form-group">
          <label htmlFor="periodOfHospitalization">
            Περίοδο νοσηλείας <span className="required">*</span>
          </label>
          <input
            type="text"
            id="periodOfHospitalization"
            name="periodOfHospitalization"
            value={formData.periodOfHospitalization || ''}
            onChange={handleChange}
            placeholder="π.χ. 15/01/2024 - 20/01/2024"
            required
          />
        </div>
      )}

      {fields.includes('timePeriod') && (
        <div className="form-group">
          <label htmlFor="timePeriod">
            Χρονική Περίοδος <span className="required">*</span>
          </label>
          <input
            type="text"
            id="timePeriod"
            name="timePeriod"
            value={formData.timePeriod || ''}
            onChange={handleChange}
            placeholder="π.χ. 2020 - 2024"
            required
          />
        </div>
      )}

      {fields.includes('visitDate') && (
        <div className="form-group">
          <label htmlFor="visitDate">
            Ημερομηνία επίσκεψης στα ΤΕΠ <span className="required">*</span>
          </label>
          <input
            type="date"
            id="visitDate"
            name="visitDate"
            value={formData.visitDate || ''}
            onChange={handleChange}
            required
          />
        </div>
      )}

      {fields.includes('examDate') && (
        <div className="form-group">
          <label htmlFor="examDate">
            Ημερομηνία εξέτασης <span className="required">*</span>
          </label>
          <input
            type="date"
            id="examDate"
            name="examDate"
            value={formData.examDate || ''}
            onChange={handleChange}
            required
          />
        </div>
      )}

      {fields.includes('surgeryDate') && (
        <div className="form-group">
          <label htmlFor="surgeryDate">
            Ημερομηνία χειρουργείου <span className="required">*</span>
          </label>
          <input
            type="date"
            id="surgeryDate"
            name="surgeryDate"
            value={formData.surgeryDate || ''}
            onChange={handleChange}
            required
          />
        </div>
      )}

      {fields.includes('admissionDate') && (
        <div className="form-group">
          <label htmlFor="admissionDate">
            Ημερομηνία εισαγωγής <span className="required">*</span>
          </label>
          <input
            type="date"
            id="admissionDate"
            name="admissionDate"
            value={formData.admissionDate || ''}
            onChange={handleChange}
            required
          />
        </div>
      )}

      {fields.includes('clinic') && (
        <div className="form-group">
          <label htmlFor="clinic">
            Κλινική νοσηλείας
          </label>
          <input
            type="text"
            id="clinic"
            name="clinic"
            value={formData.clinic || ''}
            onChange={handleChange}
            placeholder="π.χ. Παθολογική Κλινική"
          />
        </div>
      )}

      {fields.includes('examType') && currentConfig.examTypes && (
        <div className="form-group">
          <label htmlFor="examType">
            Είδος εξέτασης
          </label>
          <select
            id="examType"
            name="examType"
            value={formData.examType || ''}
            onChange={handleChange}
          >
            <option value="">Επιλέξτε είδος εξέτασης</option>
            {currentConfig.examTypes.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>
      )}

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="email">
            Email <span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email || ''}
            onChange={handleChange}
            placeholder="example@email.com"
            required
          />
          <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
            Το ίδιο με αυτό που δηλώσατε στην ΥΔ ή Εξουσιοδότηση
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="phone">
            Τηλ. Επικοινωνίας <span className="required">*</span>
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone || ''}
            onChange={handlePhoneChange}
            placeholder="2101234567"
            inputMode="numeric"
            pattern="\d{10,15}"
            title="Εισάγετε μόνο αριθμούς (10-15 ψηφία)"
            required
          />
        </div>
      </div>
    </div>
  );
};

export default GenericDL;








